'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../adapter/index.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class Competitions {
  leaderboardByAchievement(achievement, page, itemsPerPage) {
    const params = { achievement, page, itemsPerPage };
    return index.adapter.competitions.leaderboardByAchievement(params);
  }
  upcoming(options) {
    return index.adapter.competitions.upcoming(options);
  }
  all(options) {
    return index.adapter.competitions.all(options).then((allCompetitions) => allCompetitions.map(this.addCurrentMilestone.bind(this)));
  }
  get(params) {
    return index.adapter.competitions.get(params);
  }
  optIn(competitionId) {
    return __async(this, null, function* () {
      const res = yield index.adapter.competitions.optIn({ competitionId });
      return res.success;
    });
  }
  optOut(competitionId) {
    return __async(this, null, function* () {
      const res = yield index.adapter.competitions.optOut({ competitionId });
      return res.success;
    });
  }
  getScheduled(params) {
    return index.adapter.competitions.getScheduled(params);
  }
  getScheduledDetails() {
    return index.adapter.competitions.getScheduledDetails();
  }
  resolveMilestoneData(milestones, achievementValue, minAmount = 0) {
    if (!Array.isArray(milestones)) {
      throw TypeError();
    }
    if (!Number.isFinite(achievementValue)) {
      throw TypeError();
    }
    let previous = { value: 0, winAmount: 0 };
    const milestonesCopy = Array.prototype.slice.call(milestones);
    for (let index = 0; index < milestonesCopy.length; index++) {
      const end = achievementValue >= milestonesCopy[index].value && !milestonesCopy[index].loopMultiplier && index === milestonesCopy.length - 1;
      if (achievementValue < milestonesCopy[index].value || end) {
        return this.milestoneData(milestonesCopy[index], previous, achievementValue, minAmount, index, end);
      }
      const multiplier = Number(milestonesCopy[index].loopMultiplier);
      if (multiplier >= 1 && index === milestonesCopy.length - 1) {
        const spread = milestonesCopy[index].value - previous.value;
        const clonedMilestone = __spreadValues({}, milestonesCopy[index]);
        clonedMilestone.value = clonedMilestone.value + spread * multiplier;
        milestonesCopy.push(clonedMilestone);
      }
      previous = milestonesCopy[index];
    }
    throw new Error("Milestone value out of range");
  }
  addCurrentMilestone(competition) {
    let currentMilestone;
    try {
      currentMilestone = this.resolveMilestoneData(competition.milestones, competition.achievementValue, competition.minAmount);
    } catch (e) {
      console.error(e);
    }
    return __spreadProps(__spreadValues({}, competition), {
      currentMilestone
    });
  }
  milestoneData(milestone, previous, achievementValue, minAmount, index, end) {
    const maxValue = milestone.value - previous.value;
    const value = maxValue + achievementValue - milestone.value;
    const percentage = Math.floor(value / maxValue * 100);
    const step = this.resolveSteps(maxValue);
    return {
      isComplete: end,
      level: index + 1,
      min: 0,
      max: maxValue,
      percentage,
      step,
      type: step === 0 ? "percent" : "numeric",
      remaining: maxValue - value,
      remainingPercentage: 100 - percentage,
      value,
      win: milestone.winAmount,
      minAmount,
      isRoleChange: milestone.hasOwnProperty("roles"),
      isSegmentChange: milestone.hasOwnProperty("segment"),
      token: milestone.token
    };
  }
  resolveSteps(maxValue) {
    if (maxValue > 1e3) {
      return 0;
    } else if (maxValue > 100) {
      return 100;
    } else if (maxValue > 10) {
      return 10;
    } else {
      return 1;
    }
  }
}
const competitions = new Competitions();

exports.competitions = competitions;
